import { menuUtil } from "../../../common";
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { SmallCustomIcon } from "../../layer00";

export type CalendarAppointmentMenuProps = menuUtil.IBaseMenuProps & {
  onMarkAsNot1on1: () => void;
  onConfirm?: () => void;
  onViewInCalendar?: () => void;
};

export const CalendarAppointmentMenu = (
  props: CalendarAppointmentMenuProps
) => {
  return (
    <Menu
      id={props.id}
      open={props.open}
      anchorEl={props.anchorEl ?? null}
      onClick={(e) => props.handleClick(e)}
      onClose={() => props.handleClose()}
    >
      {props.onConfirm && (
        <MenuItem
          onClick={() => {
            props.onConfirm?.();
            props.handleClose();
          }}
        >
          <ListItemIcon>
            <SmallCustomIcon icon="CHECK" />
          </ListItemIcon>
          <ListItemText>Confirm 1:1</ListItemText>
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          props.onMarkAsNot1on1();
          props.handleClose();
        }}
      >
        <ListItemIcon>
          <SmallCustomIcon icon="WARNING" />
        </ListItemIcon>
        <ListItemText>Mark as not 1:1</ListItemText>
      </MenuItem>
      {props.onViewInCalendar && (
        <MenuItem
          onClick={() => {
            props.onViewInCalendar?.();
            props.handleClose();
          }}
        >
          <ListItemIcon>
            <SmallCustomIcon icon="CALENDAR" />
          </ListItemIcon>
          <ListItemText>View in Calendar</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};
